import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Button, Modal, Form} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';
import { ExclamationCircleFilled } from '@ant-design/icons';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import Loader from '../loader';

const { TextArea } = Input;

const {RangePicker} = DatePicker;

export default function CommissionReport() {

  const [commissions, setCommissions] = useState([]);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const location = useLocation();
  const startOfDay = moment().subtract(30,'day').format('YYYY-MM-DD HH:mm:ss');
  const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
  const [date,setDate] = useState({startDate: startOfDay,endDate: endOfTmr})
  const [form] = Form.useForm();


  async function fetchData() {
    const masterId =  location.state?.id;
    setLoading(true)
    let res = await axios.get(`/report/getCommissionReportByMasterId?masterId=${masterId}&startDate=${date.startDate}&endDate=${date.endDate}`)
    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setCommissions(res.data)
    setLoading(false)
  }

  const handleCloseAlert = () => setOpenAlert(false)

  const handleDateChange = async (v,dateString) => setDate({startDate: `${dateString[0]} 00:00:00`,endDate: `${dateString[1]} 23:59:59`});

  useEffect(()=> {
      fetchData()
  },[date])

  const setDefaultCopyText = () => {
    console.log("location",location.state)
    const name = location.state?.name;
    const dateRange = `${moment(date.startDate).format("DD-MM-YYYY")} / ${moment(date.endDate).format("DD-MM-YYYY")}`;
    let totalCommission = 0;
    let totalBetAmount = 0;
    let totalWin = 0;
    let winAndLose = 0;
    commissions.forEach(comm => {
      totalCommission += Number(comm.commission);
      totalBetAmount += Number(comm.bet_amount);
      totalWin += Number(comm.winned_amount);
    });
    winAndLose = (Number(totalWin) - Number(totalBetAmount)) + Number(totalCommission);
    const text = 
    `${name}
${dateRange}
ထိုးကြေးစုစုပေါင်း =  ${totalBetAmount}
ကော်          =  ${totalCommission}
+/-          =  ${winAndLose}
                `
    form.setFieldsValue({copyText: text})
  }
  const columns = [
      {
        title: 'From',
        dataIndex: 'period_start',
        key: 'period_start',
        render: (date) => moment(date).format("DD-MM-YYYY")
      },
      {
        title: 'To',
        key: 'period_end',
        dataIndex: 'period_end',
        render: (date) => moment(date).format("DD-MM-YYYY")
      },
      {
        title: ' Profit',
        key: 'profit',
        dataIndex: 'profit',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Win',
        key: 'win',
        dataIndex: 'win',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Loss',
        key: 'loss',
        dataIndex: 'loss',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Bet Amount',
        key: 'bet_amount',
        dataIndex: 'bet_amount',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'Tax Amount',
        key: 'tax_amount',
        dataIndex: 'tax_amount',
        render : (amount) => Number(amount).toLocaleString()
      },
      {
        title: 'commission',
        dataIndex: 'commission',
        key: 'commission',
        render : (amount) => Number(amount).toLocaleString()
      },
      // {
      //   title: 'Master Comm',
      //   dataIndex: 'master_commission',
      //   key: 'master_commission',
      //   render : (amount) => Number(amount).toLocaleString()
      // },
      // {
      //   title: 'Agent Comm',
      //   dataIndex: 'agent_commission',
      //   key: 'agent_commission',
      //   render : (amount) => Number(amount).toLocaleString()
      // }
      
  ];

  const { confirm } = Modal;
  const showTextArea = () => {
    setDefaultCopyText();
    confirm({
      mask: false,
      centered: true,
      maskClosable: true, 
      // cancelButtonProps: { style: { display: 'none' } },
      okText: "Copy",
      title: "Copy to clipboard!",
      icon: <ExclamationCircleFilled />,
      onOk() {
        handleCopy()
      },
      content: 
        <Form
        name="basic"
        initialValues={{ remember: true }}
        autoComplete="off"
        form={form}
        > 
        <Form.Item name="copyText">
          <TextArea
          disabled={true}
          style={{ resize: "none",height: 140,width: "100%",color: "black",fontWeight: "normal",background: "white" ,borderWidth: "0"}}
          />
        </Form.Item>
      </Form>
     ,
      
    });
  };

  const handleCopy = () => {
    const copyText = form.getFieldsValue().copyText;
    navigator.clipboard.writeText(copyText);
  }

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex',justifyContent: "space-between"}}>
        <div style={{display: 'flex',alignItems: 'center'}}>
          <RangePicker
                value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
                onChange={(v,dateString)=> handleDateChange(v,dateString)}
          />
         <Button style={{ marginLeft: "2rem", backgroundColor: "rgb(103, 58, 183)",color: 'white',padding: "0 2rem 0 2rem" }} type='dashed' onClick={()=> showTextArea()} >
          Share
        </Button>
        </div>        
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={commissions} />
      
    </div>
  </div>
  )
}


